import { View } from '../../../utils';

export enum Overlay {
  Placement1 = 'placement1',
  Placement2 = 'placement2',
}

export const overlayVariant = (
  view: View,
  withOverLay: Boolean,
): Overlay | undefined => {
  if (!withOverLay) {
    return undefined;
  }
  switch (view) {
    case View.View1: {
      return Overlay.Placement1;
    }
    case View.View2: {
      return Overlay.Placement2;
    }
  }
};
